export const AthleteLinks = ({ athlete, pathName, classNames, query }) => {
  if (!athlete) return null;
  const organizationCoach = query?.organizationCoach || undefined;
  return (
    <ul role="toggle-links" className={classNames}>
      <li
        className={
          pathName.startsWith("/athlete-portal/profile")
            ? "active main-toggle-link-active"
            : ""
        }
      >
        <a
          data-button-type={
            pathName.startsWith("/athlete-portal/profile")
              ? "outline"
              : "text-white"
          }
          role="button"
          href={
            organizationCoach
              ? `/athlete-portal/profile/?athlete=${athlete._id}&section=dashboard&organizationCoach=${organizationCoach}`
              : `/athlete-portal/profile/?athlete=${athlete._id}&section=dashboard`
          }
        >
          Profile
        </a>
      </li>
      <li
        className={
          pathName.startsWith("/athlete-portal/programs")
            ? "active main-toggle-link-active"
            : ""
        }
      >
        <a
          data-button-type={
            pathName.startsWith("/athlete-portal/programs")
              ? "outline"
              : "text-white"
          }
          role="button"
          href={
            organizationCoach
              ? `/athlete-portal/programs?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
              : `/athlete-portal/programs?athlete=${athlete._id}`
          }
        >
          Programs
        </a>
      </li>
      {!((athlete.status && athlete.status.inactive) || false) && [
        <li
          className={
            pathName.startsWith("/athlete-portal/calendar")
              ? "active main-toggle-link-active"
              : ""
          }
          key={`calendar-link-01`}
        >
          <a
            data-button-type={
              pathName.startsWith("/athlete-portal/calendar")
                ? "outline"
                : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/calendar/?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/calendar/?athlete=${athlete._id}`
            }
          >
            Calendar
          </a>
        </li>,
        <li
          className={`mobile-hidden${
            pathName.startsWith("/athlete-portal/metrics")
              ? " active main-toggle-link-active"
              : ""
          }`}
          key={`reports-link-01`}
        >
          <a
            data-button-type={
              pathName.startsWith("/athlete-portal/metrics")
                ? "outline"
                : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/metrics/exercise-history?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/metrics/exercise-history?athlete=${athlete._id}`
            }
          >
            Reports
          </a>
        </li>,
        <li
          className={`only-show-mobile${
            pathName.startsWith("/athlete-portal/metrics")
              ? " active main-toggle-link-active"
              : ""
          }`}
          key={`reports-link-mobile`}
        >
          <a
            data-button-type={
              pathName.startsWith("/athlete-portal/metrics")
                ? "outline"
                : "text-white"
            }
            role="button"
            href={`/athlete-portal/metrics/reports-menu?athlete=${athlete._id}`}
          >
            Reports
          </a>
        </li>,
        <li
          className={
            pathName.startsWith("/athlete-portal/nutrition")
              ? "active main-toggle-link-active"
              : ""
          }
          key={`nutrition-link-03`}
        >
          <a
            data-button-type={
              pathName.startsWith("/athlete-portal/nutrition")
                ? "outline"
                : "text-white"
            }
            role="button"
            href={
              organizationCoach
                ? `/athlete-portal/nutrition?athlete=${athlete._id}&organizationCoach=${organizationCoach}`
                : `/athlete-portal/nutrition?athlete=${athlete._id}`
            }
          >
            Nutrition
          </a>
        </li>,
      ]}
    </ul>
  );
};
